module.exports = __webpack_public_path__ + "static/media/new.fe823e35.png";